export default {
  'config': {
    'form_group': '分组',
    'form_select_group': '选择分组',
    'form_type': '类型',
    'form_select_type': '选择类型',
    'form_title': '标题',
    'form_enter_title': '请填写标题',
    'form_name': '名称',
    'form_enter_name': '请填写名称，填写大小写字母、数字、下划线及其组合',
    'form_options': '配置项',
    'form_enter_options': '请填写配置项',
    'form_options_value': '配置值',
    'form_enter_options_value': '请填写配置值',
    'form_description': '描述',
    'form_enter_description': '请填写描述',
    'form_listorder': '排序',
    'form_enter_listorder': '请填写排序',
    'form_group_none': '未分组',
    'form_type_text': '文本',
    'form_type_textarea': '文本框',
    'form_type_array': '数组',
    'form_type_number': '数字',
    'form_type_radio': '单选',
    'form_type_checkbox': '复选',
    'form_type_select': '下拉',
    'form_type_switch': '开关',
    'form_type_image': '单图',
    'form_type_rate': '评分',
    'form_type_color': '颜色',
    'form_type_slider': '滑块',
    'form_type_time': '时间',
    'form_type_date': '日期',
    'form_type_range_time': '时间范围',
    'form_type_range_date': '日期范围',
    'form_show': '显示',
    'form_show_enable': '启用',
    'form_show_disable': '禁用',
    'form_status': '状态',
    'form_status_enable': '启用',
    'form_status_disable': '禁用',
    'form_save': '提交',
    'form_create_success': '添加配置成功',
    'form_update_success': '编辑配置成功',

    'rules_type_required': '类型不能为空',
    'rules_title_required': '标题不能为空',
    'rules_name_required': '名称不能为空',
    'rules_listorder_required': '排序不能为空',

    'search_title': '配置管理',
    'search_searchword': '请输入关键字',
    'search_group': '分组',
    'search_group_none': '未分组',
    'search_status': '状态',
    'search_status_enable': '启用',
    'search_status_disable': '禁用',
    'search_sort_asc': '正序',
    'search_sort_desc': '倒叙',
    'search_btn': '搜索',
    'search_create_config': '添加',

    'table_name': '名称',
    'table_title': '标题',
    'table_type': '类型',
    'table_group': '分组',
    'table_listorder': '排序',
    'table_create_time': '添加时间',
    'table_status': '状态',
    'table_actions': '操作',
    'table_detail': '详情',
    'table_update': '编辑',
    'table_delete': '删除',
    'table_listorder_success': '配置排序成功',

    'dialog_detail': '配置详情',
    'dialog_create': '添加配置',
    'dialog_update': '编辑配置',

    'detail_id': 'ID',
    'detail_group': '分组',
    'detail_type': '类型',
    'detail_title': '标题',
    'detail_name': '名称',
    'detail_options': '配置项',
    'detail_options_value': '配置值',
    'detail_description': '描述',
    'detail_listorder': '排序',
    'detail_show': '显示',
    'detail_status': '激活状态',
    'detail_update_time': '最后更新',
    'detail_create_time': '添加时间',

    'enable_success': '配置启用成功',
    'disable_success': '配置禁用成功',
    'confirm_delete': '确认要删除该配置吗？',
    'confirm_delete_success': '删除配置成功',

    'setting_title': '网站设置',
    'setting_save': '提交',
    'setting_loading': '加载中..',
    'setting_save_success': '提交更新成功'
  }
}
